import { Template } from '../templates/template'

const AzubiWikiPage: React.FunctionComponent = () => {
  return (
    <>
      <Template type="Main">
        <div>WIKI</div>
      </Template>
    </>
  )
}

export default AzubiWikiPage
